<nav class="breadcrumbs">
  @for (breadcrumb of breadcrumbs(); track breadcrumb.url; let last = $last) {
    @if (!last) {
      <a [routerLink]="breadcrumb.url" class="breadcrumb-link">
        {{ breadcrumb.label | breadcrumbTranslate }}
      </a>
      <span class="breadcrumb-separator">/</span>
    } @else {
      <span class="breadcrumb-active">{{ breadcrumb.label | breadcrumbTranslate }}</span>
    }
  }
</nav>